import { useCallback } from 'react';
import { useAxios } from 'api/axios';
import { ActivitiesParams, Activity } from './activities.types';

export const useGetActivities = () => {
  const [{ data, loading }, getActivitiesReq] = useAxios<{
    result: { data: Activity[]; count: number };
  }>({
    method: 'GET',
  });

  const getActivities = useCallback(
    ({
      filterText = '',
      pageNumber,
      resultSize,
      type,
      direct,
    }: ActivitiesParams) => getActivitiesReq({
        url: `/activity`,
        params: { filterText, pageNumber, resultSize, type, direct },
      }),
    [getActivitiesReq],
  );

  return {
    data: data?.result.data,
    loading,
    getActivities,
  };
};
